export const usuarios = {
  titulo: 'Usuários e perfis',
  descricao: 'Usuários que já entraram no My Update e seus perfis.',
  filtros: {
    limpar: 'Limpar tudo',
    rotulo: '{{filtro}}: {{valor}}',
    aplicados: 'Filtros aplicados',
    remover: 'Remover filtro {{filtro}}',
    botao: 'Filtros',
    fechar: 'Fechar',
    perfis: { administrador: 'Administrador', profissional: 'Só profissional' },
    entrou: { rotulo: 'Entrou no sistema', sim: 'Sim', nao: 'Não' },
  },
  porPagina: 'Itens por página',
  semResultado: 'Nenhum usuário com esses filtros.',
  colunas: {
    nome: 'Nome',
    email: 'E-mail',
    perfis: 'Perfis',
    ultimoLogin: 'Último acesso ao sistema',
    cadastro: 'Cadastro no Axiis',
    acoes: 'Ações',
  },
  nuncaEntrou: 'Nunca entrou',
  vinculo: {
    vinculado: 'Vinculado',
    sem_correspondencia: 'Sem correspondência',
    duplicado: 'Duplicado',
    nao_verificado: 'Não verificado',
  },
  acoes: { promover: 'Tornar administrador', rebaixar: 'Remover administrador' },
  confirmar: {
    promover: 'Tornar {{nome}} administrador?',
    rebaixar: 'Remover o perfil de administrador de {{nome}}? A pessoa continua como profissional.',
  },
  promovido: '{{nome}} agora é administrador.',
  rebaixado: '{{nome}} não é mais administrador.',
  vazio: 'Nenhum usuário encontrado.',
} as const;
